import { cloneDeep } from 'lodash';
import { ConversationMessageView, ConversationParticipantView } from '@mark43/cad-api';
import { MessagingStore } from '../store/messaging-store';
import { participantToAssignedParticipant } from './conversation-participant-helpers';

export const incrementBookmarkedMessageCount = (
    store: MessagingStore,
    bookmarkedMessage: ConversationMessageView,
    participantIdentity: ConversationParticipantView
) => {
    const bookmarkedConversation =
        store.data?.bookmarkedConversations?.[bookmarkedMessage.conversationId];

    if (bookmarkedConversation) {
        // if conversation exists in store
        // update conversation's assignedParticipantUnreadInfos

        const { assignedParticipantUnreadInfos } = bookmarkedConversation;

        const assignedParticipant = assignedParticipantUnreadInfos.find(
            ({ participantId }) => participantId === participantIdentity.id
        );

        store.setBookmarkedConversation({
            ...cloneDeep(bookmarkedConversation),
            assignedParticipantUnreadInfos: [
                ...assignedParticipantUnreadInfos.filter(
                    ({ participantId }) => participantId !== participantIdentity.id
                ),
                assignedParticipant
                    ? {
                          ...assignedParticipant,
                          bookmarkedMessagesCount: assignedParticipant.bookmarkedMessagesCount + 1,
                      }
                    : participantToAssignedParticipant(participantIdentity, 1),
            ],
        });
    } else {
        // if conversation doesn't exist in store
        // add conversation to store with assigned participant

        const conversation = store.data?.conversations?.[bookmarkedMessage.conversationId];

        if (conversation === undefined) {
            throw new Error('conversation not found');
        }

        store.setBookmarkedConversation({
            ...cloneDeep(conversation),
            newestMessageDateUtc: bookmarkedMessage.createdDateUtc,
            newestMessageId: bookmarkedMessage.id,
            assignedParticipantUnreadInfos: [
                participantToAssignedParticipant(participantIdentity, 1),
            ],
        });
    }
};

export const decrementBookmarkedMessageCount = (
    store: MessagingStore,
    unbookmarkedMessage: ConversationMessageView,
    participantIdentity: ConversationParticipantView
) => {
    const bookmarkedConversation =
        store.data?.bookmarkedConversations?.[unbookmarkedMessage.conversationId];

    if (bookmarkedConversation) {
        // if conversation exists in store
        // decrement participants bookmarks message count, or remove the conversation if 0

        const assignedParticipant = bookmarkedConversation.assignedParticipantUnreadInfos.find(
            ({ participantId }) => participantId === participantIdentity.id
        );

        let updatedAssignedParticipant;

        if (assignedParticipant !== undefined && assignedParticipant.bookmarkedMessagesCount > 1) {
            updatedAssignedParticipant = {
                ...assignedParticipant,
                bookmarkedMessagesCount: assignedParticipant.bookmarkedMessagesCount - 1,
            };
        }

        const otherAssignedParticipants = bookmarkedConversation.assignedParticipantUnreadInfos.filter(
            ({ participantId }) => participantId !== participantIdentity.id
        );

        if (otherAssignedParticipants.length >= 1 || updatedAssignedParticipant !== undefined) {
            store.setBookmarkedConversation({
                ...cloneDeep(bookmarkedConversation),
                assignedParticipantUnreadInfos: [
                    ...otherAssignedParticipants,
                    ...(updatedAssignedParticipant === undefined
                        ? []
                        : [updatedAssignedParticipant]),
                ],
            });
        } else {
            // if last assignedParticipantUnreadInfo, remove bookmarkedConversation
            store.removeBookmarkedConversation(unbookmarkedMessage.conversationId);
        }
    }
};
